import axios from "axios";
import { API_URL } from "../apiConfig";

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export async function getNmlSuzhouCriticalPath({
  includeClosed = false,
  board = "SUZHOU",
  clientView = false,
} = {}) {
  const response = await axios.get(`${API_URL}/api/nml-suzhou/critical-path`, {
    params: {
      includeClosed: includeClosed ? "1" : "0",
      board,
      clientView: clientView ? "1" : "0",
    },
    headers: authHeader(),
  });
  return response.data;
}

export async function enrollNmlSuzhouProduct(productId, boardKey) {
  const response = await axios.post(
    `${API_URL}/api/nml-suzhou/enroll`,
    { productId, boardKey },
    { headers: authHeader() },
  );
  return response.data;
}

export async function setNmlSuzhouClosed({ productId, isClosed }) {
  const response = await axios.post(
    `${API_URL}/api/nml-suzhou/closed`,
    { productId, isClosed },
    { headers: authHeader() },
  );
  return response.data;
}

export async function saveNmlSuzhouField({ productId, field, value }) {
  const response = await axios.put(
    `${API_URL}/api/nml-suzhou/field`,
    { productId, field, value },
    { headers: authHeader() },
  );
  return response.data;
}

export async function saveNmlSuzhouTask({
  productId,
  taskKey,
  expectedDate,
  realDate,
  slot,
}) {
  const response = await axios.put(
    `${API_URL}/api/nml-suzhou/task`,
    { productId, taskKey, expectedDate, realDate, slot },
    { headers: authHeader() },
  );
  return response.data;
}

export async function importNmlSuzhouRows(rows, boardKey = "SUZHOU") {
  const response = await axios.post(
    `${API_URL}/api/nml-suzhou/import`,
    { rows, boardKey },
    { headers: authHeader() },
  );
  return response.data;
}

export async function getNmlSuzhouPhotoBlob(productId) {
  const response = await axios.get(
    `${API_URL}/api/nml-suzhou/photo/${productId}`,
    {
      headers: authHeader(),
      responseType: "blob",
      validateStatus: (status) => status === 200 || status === 404,
    },
  );
  if (response.status !== 200 || !response.data || response.data.size < 32) {
    return null;
  }
  const type = String(response.data.type || "");
  if (type.includes("json") || type.includes("text")) return null;
  return URL.createObjectURL(response.data);
}
